export default class CityManagementColumnModel {
    static CityManagementColumn = [
      {
        title: 'City Name',
        align: 'left',
        field: 'cityName'
      }
    ]
}
